/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IIframeViewProps } from './c-iframe';

/**
 *
 * IFrameView component.
 * @extends {React.PureComponent<IIframeViewProps>}
 */
export class IFrameView extends React.PureComponent<IIframeViewProps> {
    public render(): JSX.Element | null {
        const { Heading, IframeContainer, IFrame, alert, cookieConsentAccepted, showForm, closeScriptModal } = this.props;

        let nlTitle: string = '';
        let nlSubtitle: string = '';

        const channelNaturalId: string | undefined = this.props.context.request.channel?.ChannelNaturalId;
        switch (channelNaturalId) {
            case 'PimkieDE':
                nlTitle = 'Abonnieren Sie unseren Newsletter';
                nlSubtitle =
                    'Wenn Sie über alle Neuheiten und Trends auf dem Laufenden bleiben wollen oder exklusive Inhalte entdecken möchten, abonnieren Sie jetzt unseren Newsletter.';
                break;
            case 'PimkieES':
                nlTitle = 'Suscríbete a nuestra newsletter';
                nlSubtitle =
                    'Si quieres estar al corriente de todas las novedades, tendencias o descubrir contenido exclusivo, suscríbete ahora a nuestra newsletter.';
                break;
            case 'PimkiePT':
                nlTitle = 'Subscreva a nossa newsletter';
                nlSubtitle =
                    'Se quiser estar a par de todas as novidades, tendências ou descobrir conteúdo exclusivo, subscreva já a nossa newsletter.';
                break;
            case 'PimkieAT':
                nlTitle = 'Abonnieren Sie unseren Newsletter';
                nlSubtitle =
                    'Wenn Sie über alle Neuheiten und Trends auf dem Laufenden bleiben wollen oder exklusive Inhalte entdecken möchten, abonnieren Sie jetzt unseren Newsletter.';
                break;

            default:
                break;
        }

        // <span className='close-button' onClick={closeScriptModal} role='button'>
        //     X
        // </span>

        return (
            <Module {...IframeContainer}>
                <div className='overlay-script-form' style={showForm ? { display: 'block' } : { display: 'none' }}></div>
                <div className='script-form' style={showForm ? { display: 'block' } : { display: 'none' }}>
                    <div className='nl-title-container mb-10 mb-16-md'>
                        <div className='nl-title text-b-18 text-color-primary'>{nlTitle}</div>
                        <div className='nl-close-btn' onClick={closeScriptModal}>
                            <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                <path
                                    d='M14.2981 15.3588C14.591 15.6517 15.0659 15.6517 15.3588 15.3588C15.6517 15.0659 15.6517 14.591 15.3588 14.2981L14.2981 15.3588ZM9.70191 8.64125C9.40901 8.34835 8.93414 8.34835 8.64125 8.64125C8.34835 8.93414 8.34835 9.40901 8.64125 9.70191L9.70191 8.64125ZM8.64124 14.2981C8.34835 14.591 8.34835 15.0659 8.64124 15.3588C8.93413 15.6517 9.40901 15.6517 9.7019 15.3588L8.64124 14.2981ZM15.3588 9.70191C15.6516 9.40901 15.6516 8.93414 15.3588 8.64125C15.0659 8.34835 14.591 8.34835 14.2981 8.64125L15.3588 9.70191ZM15.3588 14.2981L9.70191 8.64125L8.64125 9.70191L14.2981 15.3588L15.3588 14.2981ZM9.7019 15.3588L15.3588 9.70191L14.2981 8.64125L8.64124 14.2981L9.7019 15.3588ZM12 22.75C17.9371 22.75 22.75 17.9371 22.75 12H21.25C21.25 17.1086 17.1086 21.25 12 21.25V22.75ZM1.25 12C1.25 17.9371 6.06294 22.75 12 22.75V21.25C6.89137 21.25 2.75 17.1086 2.75 12H1.25ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12H2.75C2.75 6.89137 6.89137 2.75 12 2.75V1.25ZM12 2.75C17.1086 2.75 21.25 6.89137 21.25 12H22.75C22.75 6.06294 17.9371 1.25 12 1.25V2.75Z'
                                    fill='#28303F'
                                />
                            </svg>
                        </div>
                    </div>
                    <div className='text-r-16 mb-20 mb-30-md text-color-secondary'>{nlSubtitle}</div>
                    {alert}
                    {cookieConsentAccepted && cookieConsentAccepted ? (
                        <>
                            {Heading}
                            {IFrame}
                        </>
                    ) : null}
                </div>
            </Module>
        );
    }
}
export default IFrameView;
